import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { SummaryOfTerminationTermsUseCaseInterface } from 'domain/usecases';

export class RemoteSummaryOfTerminationTerms
  implements SummaryOfTerminationTermsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<SummaryOfTerminationTermsUseCaseInterface.Result>,
  ) {}

  async execute(
    params: SummaryOfTerminationTermsUseCaseInterface.Params,
  ): Promise<SummaryOfTerminationTermsUseCaseInterface.Result> {
    const { ...restParams } = params;

    const requestUrl = `${this.url}/report-terms-count`;

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(requestUrl, restParams),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
